var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Report',{attrs:{"broadcast-name":_vm.broadcastName,"broadcast-msg":_vm.broadcastMsg,"broadcast-user":_vm.broadcastUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }